import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { tap, filter, take, switchMap, catchError, map } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import * as fromStore from '@unico-people/shared/dashboard/data-access-store';

import { environment as environmentBenefit } from '@unico-people/benefits-dashboard/enviroment';
import { environment } from '@unico-people/shared/utils/environments';
import { getTokenStorage } from '@unico-people/shared/utils/storage';

@Injectable({
  providedIn: 'root'
})
export class DataAccessModulesGuard implements CanActivate {
  private readonly signUrl: string = environment.sign_url;
  private baseUrl: string = environment.admission_url;

  constructor(private store: Store<fromStore.DashboardState>) {}

  canActivate(route: ActivatedRouteSnapshot) {
    return this.checkStore().pipe(
      switchMap(() => {
        return this.checkRedirect();
      }),
      catchError(() => of(false))
    );
  }

  checkRedirect(): Observable<boolean> {
    let result: Observable<boolean> = of(true);
    this.checkModules().subscribe(modules => {
      const hasAdmission = modules.admissions;
      const hasSignature = modules.signature;
      if (hasAdmission) {
        result = of(true);
      } else if (hasSignature) {
        window.location.href = `${this.signUrl}/login-integration?product_id=99c3dfc5-7518-4d7c-9e75-e54d920721fd&redirect_uri=${this.baseUrl}`;
        result = of(false);
      }
    });
    return result;
  }

  checkModules(): Observable<any> {
    return this.store.pipe(select(fromStore.getModulesEntities));
  }

  checkStore(): Observable<boolean> {
    return this.store.pipe(
      select(fromStore.getModulesLoaded),
      tap(loaded => {
        if (!loaded) {
          this.store.dispatch(fromStore.LoadModules({ payload: getTokenStorage()}));
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
